import React from 'react';
import { ServicePageLayout } from './ServicePageLayout';
export function BarberWebsiteDublin() {
  const content = <div className="space-y-6 text-white/80" data-id="element-679">
      <p data-id="element-680">
        The barbering industry in Dublin is booming, from classic shops in the
        Liberties to modern studios in the Docklands. Style is your business,
        and your website should reflect that. A clunky, outdated website tells
        customers you're behind the times. A sharp, modern site tells them
        they're in good hands.
      </p>

      <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-681">
        Showcase Your Cuts & Style
      </h2>
      <p data-id="element-682">
        Your work is visual. We build websites that put your portfolio front and
        center. High-resolution galleries, Instagram integration, and a clean
        aesthetic help you attract the clientele you want. Whether you
        specialize in fades, beard trims, or hot towel shaves, we make sure your
        skills shine.
      </p>

      <h3 className="text-xl font-bold text-[#c9a84c] mt-6 mb-2" data-id="element-683">
        Must-Haves for Barber Websites
      </h3>
      <ul className="list-disc pl-6 space-y-2" data-id="element-684">
        <li data-id="element-685">
          <strong data-id="element-686">Online Booking:</strong> Link to Booksy, Fresha, or your
          preferred booking system to fill your chair 24/7.
        </li>
        <li data-id="element-687">
          <strong data-id="element-688">Price List:</strong> Clear, easy-to-read service menus so
          clients know exactly what to book.
        </li>
        <li data-id="element-689">
          <strong data-id="element-690">Team Profiles:</strong> Let customers choose their favorite
          barber.
        </li>
        <li data-id="element-691">
          <strong data-id="element-692">Location & Hours:</strong> Make it easy for walk-ins to find
          you.
        </li>
      </ul>

      <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-693">
        Sharp Design, Sharp Price
      </h2>
      <p data-id="element-694">
        Get a website that looks as fresh as your cuts for just{' '}
        <strong data-id="element-695">€249</strong>. No monthly fees, no hidden costs. Just a one-time
        payment for a professional site that helps you grow your brand and fill
        your appointment book.
      </p>
    </div>;
  const faqs = [{
    q: 'Can I link my booking app?',
    a: 'Yes, we seamlessly integrate links to Booksy, Fresha, or any other booking platform you use.'
  }, {
    q: 'Does it work on mobile?',
    a: '100%. Most of your clients will book from their phones, so we ensure your site is perfectly optimized for mobile devices.'
  }, {
    q: 'Can I show my Instagram photos?',
    a: 'We can link directly to your Instagram so your latest cuts are always just a click away for visitors.'
  }, {
    q: 'How long does it take to build?',
    a: 'We can have your barber shop website live in just a few days, ready to start taking bookings.'
  }];
  const relatedServices = [{
    title: 'Electricians',
    href: '/services/electrician-website-dublin'
  }, {
    title: 'Restaurants',
    href: '/services/restaurant-website-dublin'
  }, {
    title: 'Trades',
    href: '/services/trades-website-dublin'
  }, {
    title: 'Hotels',
    href: '/services/hotel-website-ireland'
  }];
  return <ServicePageLayout title="Website Design For Barbers Dublin | Book More Clients" metaDescription="Stylish website design for Dublin barber shops. Integrate booking systems, showcase your portfolio, and fill your chairs. Just €249." heroTitle="Website Design For Barbers Dublin" heroSubtitle="Fill your chairs with a sharp, modern website that showcases your style and makes booking easy." content={content} faqs={faqs} relatedServices={relatedServices} data-id="element-696" />;
}